import { useEffect, useState } from "react";
import { MdAdminPanelSettings, MdLocalHospital, MdPerson } from "react-icons/md";
import { getInlineLoader } from "../Helpers";
import logo from '../assets/logo.png';

export default function DonateContent() {
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  const portals = [
    { title: "Hospium Core", description: "Hospital and care-team access", icon: <MdLocalHospital size={48} /> },
    { title: "Hospium Self Care", description: "Patient portal access", icon: <MdPerson size={48} /> },
    { title: "Hospium Admin", description: "Authorized platform administration", icon: <MdAdminPanelSettings size={48} /> },
  ];

  return (
    <div className="MainBodySection" style={{ paddingBottom: "50px", paddingTop: "50px" }}>
      <div className="container"><div className="row">
        <div className="col-md-12"><h6 className="main-section-title">Portal Access<span style={{ display: "block", borderBottom: "3px solid var(--secondaryColor)", width: "50px", marginTop: "10px" }} /></h6></div>
        <div className="col-md-12 bg-primary text-center" style={{ padding: "30px" }}><img src={logo} alt="Hospium" style={{ width: "250px", maxWidth: "100%" }} /></div>
        <div className="col-md-12 text-center"><h6 className="font-semi-bold mt-5 mb-5" style={{ fontSize: "24px" }}>Choose the Hospium service you use. Secure portal links will be enabled as deployments go live.</h6></div>
        {portals.map((portal) => <div className="col-md-4 mb-3" key={portal.title}><div className="card h-100"><div className="card-body text-center text-primary">{portal.icon}<h5 className="font-bold mt-3">{portal.title}</h5><p className="text-dark">{portal.description}</p><button className="btn btn-rounded btn-outline-primary" disabled>Coming Soon</button></div></div></div>)}
      </div></div>
    </div>
  );
}
